// extracted by mini-css-extract-plugin
export default {"toggleButton":"ToggleButton_toggleButton__Q1SNS","circle":"ToggleButton_circle__5Sa-j"};